// Token-burn configuration and core constants.

/* ===== Config: set these when your token is live (self-hosted build) ===== */
const CONFIG={
  TOKEN_SYMBOL:'$SCLANS',
  TOKEN_MINT:'5PwYusKfXKZJk6HHbiPo8fvfaH5t8KLzBiHDPWynpump', // $SOLCLANS mint (pump.fun, Token-2022, 6 decimals)
  TOKEN_DECIMALS:6,
  TOKEN_PROGRAM:'TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb', // Token-2022 (the classic program is TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA)
  RPC:'https://api.mainnet-beta.solana.com', // only used without the Supabase server; with it, all Solana lookups happen server-side
  // Where token payments for gems go. Leave '' to burn the tokens instead; set your admin wallet address to collect them.
  // (On Supabase also run: supabase secrets set ADMIN_WALLET=<same address>)
  ADMIN_WALLET:'9eGA9bdEsQSuN6cmkiSt2odnNP43rJ44Gc69jQmHSkrq', // Sol Clans treasury (also the token deployer)
  TOKENS_PER_GEM:1000,             // base price before discounts
  GEM_PACKS:[{gems:100,off:.5},{gems:500,off:.5},{gems:1200,off:.5},{gems:3000,off:.6}], // off = discount
  // Email + password accounts (register, confirmation email, log in) on the login screen. false hides the button (players who
  // already joined by email can't log in until it is back). Server-side stop for new accounts: npx supabase secrets set EMAIL_LOGIN=off
  EMAIL_LOGIN:true,
  // Community leaderboard of raid sharers (header chip next to the burns; needs the server: report-share + share_board()).
  // false hides it. Undo on the server: supabase/rollback/20261023000000_share_board_down.sql
  SHARE_BOARD:true
};
// ===== Paste your links here when you go live (leave '' to show "soon") =====
const LINKS={
  CA:'5PwYusKfXKZJk6HHbiPo8fvfaH5t8KLzBiHDPWynpump', // token contract address (mint)
  X:'https://x.com/solclansonsol', // Sol Clans on X
  TELEGRAM:'https://t.me/SolClans', // community Telegram
  GITHUB:'',  // e.g. 'https://github.com/you/sol-clans'
};
const N=40, KEY='clash-of-sol-v1'; // save key kept from the old name so existing saves still load

export { CONFIG, LINKS, KEY, N };
